import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthSessionService } from '../services/others/auth-session.service';
import { SseService } from '../services/api/sse.service';
export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authSession = inject(AuthSessionService);

  if (!authSession.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  return true;
};
